import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const mainSiteUrl = 'https://kaspreadsheet.com';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className="flex items-center gap-2 group cursor-pointer"
        >
          <span className="font-heading text-lg md:text-xl font-semibold text-foreground-950 tracking-tight">
            superbuyspread<span className="text-accent-500">.</span>skin
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
          >
            kaspreadsheet.com
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all hover:-translate-y-0.5 cursor-pointer"
          >
            superbuy sheet
            <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 space-y-2">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="block w-full px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold text-center hover:bg-primary-600 transition-all cursor-pointer"
            >
              superbuy sheet
              <i className="ri-arrow-right-line ml-1.5"></i>
            </a>

            <div className="pt-3 pb-1">
              <span className="block px-1 text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-2">
                Categories
              </span>
              <div className="space-y-0.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMenuOpen(false)}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100">
                      <i className={`${cat.icon} text-xs text-secondary-700`}></i>
                    </div>
                    <span className="font-medium">{cat.name}</span>
                    <i className="ri-arrow-right-up-line text-xs text-foreground-400 ml-auto"></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="pt-3 pb-1 border-t border-background-200/60">
              <span className="block px-1 text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-2">
                Guides
              </span>
              <Link
                to="/superbuy-spreadsheet-guide"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-book-open-line text-xs text-primary-700"></i>
                </div>
                <span className="font-medium">Ultimate Guide</span>
              </Link>
              <Link
                to="/superbuy-spreadsheet-shoes-guide"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-footprint-line text-xs text-accent-700"></i>
                </div>
                <span className="font-medium">Shoes Guide</span>
              </Link>
              <Link
                to="/superbuy-spreadsheet-hoodies-guide"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-t-shirt-line text-xs text-accent-700"></i>
                </div>
                <span className="font-medium">Hoodies Guide</span>
              </Link>
              <Link
                to="/superbuy-spreadsheet-bags-guide"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-handbag-line text-xs text-accent-700"></i>
                </div>
                <span className="font-medium">Bags Guide</span>
              </Link>
              <Link
                to="/superbuy-spreadsheet-accessories-guide"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-glasses-line text-xs text-accent-700"></i>
                </div>
                <span className="font-medium">Accessories Guide</span>
              </Link>
            </div>

            <div className="pt-2 border-t border-background-200/60"></div>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="block px-3 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
            >
              Visit kaspreadsheet.com
              <i className="ri-external-link-line ml-1 text-xs"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}